import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { CompanyModel } from '../Models/CompanyModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class CompanyServices {
  apiURL: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.apiURL = baseUrl + 'api/CompanyInformation/';
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.apiURL = sessionStorage.getItem("BaseURL") || '';
      this.apiURL = this.apiURL + 'api/CompanyInformation';
    }
  }

  createAuthorizationHeader(headers: Headers) {
    headers.append('Authorization', 'Basic ' +
      btoa('username:password'));
  }

  GetCompanyFindByUserID(TokenKey: string, UserID: number): Observable<CompanyModel> {    
    let fullAPIPath = this.apiURL + '/GetCompanyInformationFindByUserId/' + UserID;    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',        
        'Token': TokenKey
      })
    };    
    return this.http.get<CompanyModel>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  AddCompany(TokenKey: string, company: CompanyModel): Observable<number> {
    let fullAPIPath = this.apiURL + '/AddCompanyInformation/';    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    console.log(company);
    return this.http.post<number>(fullAPIPath, company, httpOptions)
      .pipe(catchError(this.handleError));
  }

  UpdateCompany(TokenKey: string, company: CompanyModel): Observable<number> {
    let fullAPIPath = this.apiURL + '/UpdateCompanyInformation/';    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this.http.post<number>(fullAPIPath, company, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private extractData(res: Response) {
    let body = res.json();
    //console.log("extractData " + body);
    return body;
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
